import script from "./ProductEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductEdit.vue?vue&type=script&setup=true&lang=js"

import "./ProductEdit.vue?vue&type=style&index=0&id=0fe27e82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fe27e82"]])

export default __exports__